import React from "react"
import Link from "gatsby-link";
// import menu from '../scripts/menu.js';
import '../styles/index.scss';
import '../styles/utils.scss';


import Banner from '../components/Banner';
import Button from '../components/Button';
import Content from '../components/Content';
import Client from '../components/Client';
import Footer from '../components/Footer';
import Form from '../components/Form';
import HalfHero from '../components/HalfHero';
import Header from '../components/Header';
import Hero from '../components/Hero';
import IconList from '../components/IconList';
import Testimonial from '../components/Testimonial';
import Testimonials from '../components/Testimonials';


import kevaAfter from '../img/clients/keva-after.jpg';
import sierra from '../img/clients/sierra.jpg';
import jennifer from '../img/clients/jennifer.jpg';


export default () => 
  <div>
    <Banner>
      <h1>Client Testimonials</h1>
    </Banner>
    <Content>
      <Client
        name={'Keva S.'}
        image={kevaAfter}
        id={'keva'}>
        <p>I met Jerron November 11, 2016. I remember this day because I had less than 8 months to meet the fitness standards my job requires or be fired. I am 5’6, weighed 250 pounds and measured at 46% body fat. I admit I was skeptical, but also desperate, so I gave him a shot. Best decision I could have made! I am happy to report that 20 days before I was to be terminated, I weighed in at 191 lbs and 34% body fat. I am still happily employed and no longer worry how I’m going to support my family without a job. November 11, 2017 I weighed in at 187 pounds, 32% body fat and the gains keep coming! If you need a trainer or are just curious, go with Jerron you won’t be sorry.</p>
      </Client>
      <Client
        name={'Jennifer T.'}
        image={jennifer}
        id={'jennifer'}>
        <p>The one-on-one personalized sessions put me at ease since the gym has never been my friend. In the 4 months that I have trained with CustomFIT I have successfully lost and kept off 27 pounds.</p>
      </Client>
      <Client
        name={'Sierra'}
        image={sierra}
        id={'sierra'}>
        <p>I began working out with Jerron when he started training at 24 Hour Fitness in December of 2016. I weight 187 pounds and had a BMI(body mass index of 29%. While training with Jerron I lost 20 pounds in 3 months time and 7% in body fat through his training and using his meal prep items. He creates a fun environment and has a unique approach to personal training!</p>
      </Client>
    </Content>
  </div>



// WEBPACK FOOTER //
// ./src/pages/testimonials.js